import { render, staticRenderFns } from "./depositosBysede.vue?vue&type=template&id=4a1ffea4"
import script from "./depositosBysede.vue?vue&type=script&lang=js"
export * from "./depositosBysede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports